import React from "react";
import Slider from "react-slick";
import bg from "../../Assets/REVIEWS.png";
import { GiPlainSquare } from "react-icons/gi";
import test1 from "../../Assets/test-1.jpg";
import { FaQuoteLeft } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  
  {
    quote: "To say that this 3-month modernization was a Herculean task would be an understatement.",
    description: "I remain convinced at this time, 2 weeks prior to occupancy, that no other construction firm in the Bay Area could have handled such a task and pulled it off successfully.",
    image: test1,
    name: "Mr. R. Ramanujam",
    designation: "Director Operations and Sustainability",
  },
  {
    quote: "Alten Construction delivered on every promise made, ensuring a seamless modernization process.",
    description: "They have an incredible team that works together to produce the best results. I would highly recommend them for any construction projects.",
    image: test1,
    name: "Mrs. S. Priya",
    designation: "Project Manager",
  },
  {
    quote: "A fantastic experience working with Alten Construction on multiple projects over the years.",
    description: "They have an unmatched commitment to quality and customer satisfaction.",
    image: test1,
    name: "Mr. A. Venkat",
    designation: "CEO, Bright Infra",
  },
  {
    quote: "The professionalism and dedication of Alten Construction are second to none! ",
    description: "Their team took extra care in understanding our needs and exceeded our expectations.",
    image: test1,
    name: "Ms. Anitha K",
    designation: "Architect, Dream Homes",
  },
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024, 
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="max-w-screen-2xl mx-auto py-16 relative">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img src={bg} alt="bg" className="w-full h-full object-cover  opacity-50" />
      </div>

      {/* Content Section */}
      <div className="relative z-10 text-center px-6">
        {/* Title */}
        <div className="flex justify-center items-center space-x-2">
          <GiPlainSquare className="text-[#068b07]" size={12} />
          <p className="text-gray-700 font-medium text-sm">TESTIMONIALS</p>
          <GiPlainSquare className="text-[#068b07]" size={12} />
        </div>

        {/* Heading */}
        <h1 className="text-4xl font-bold  text-gray-900 mt-4">What Your Clients Say?</h1>

        {/* Description */}
        <p className="text-lg text-gray-700 mt-2 max-w-2xl mx-auto">
          Our most important goal is to make our clients happy. We listen to your concerns, challenges, and goals to ensure that we deliver a quality building experience.
        </p>

        {/* Testimonial Slider */}
        <div className="mt-12 max-w-screen-xl mx-auto">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (

              <div key={index} className="p-6">
                <div className="bg-white border-b-4 border-[#068b07] p-8 text-center relative h-full flex flex-col min-h-[350px]">
                  {/* Quote Icon */}
                  <FaQuoteLeft className="text-white bg-[#068b07] text-4xl absolute -top-5 left-1/2  transform -translate-x-1/2 p-2 rounded-full" />

                  {/* Testimonial Text */}
                  <h3 className="text-lg font-semibold text-gray-800 mt-6 flex-grow ">{testimonial.quote}</h3>
                  <p className="text-gray-600 mt-4 flex-grow ">{testimonial.description}</p>

                  {/* Separator with Profile Image */} 
                  
                  <span className="flex space-x-1">
                    <GiPlainSquare className="text-[#068b07]" size={12} />
                    <div className="w-full h-[1px] relative mt-1 bg-gray-300">
                      <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 absolute right-1/2 -top-6 rounded-full" />
                    </div>
                    <GiPlainSquare className="text-[#068b07]" size={12} /> 
                  </span>

                  {/* User Info */}
                  <div className="mt-6">
                    <p className="font-bold pr-6 text-gray-900">{testimonial.name}</p>
                    <p className="text-gray-500 pr-6 text-sm">{testimonial.designation}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
